// 20260813: src/views/Config/Config.js  is a tab

import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useAuth0 } from "@auth0/auth0-react";


import { requestStubs } from "../../actions/agencyStubs";
import { fetchAgency } from "../../actions/agency";

import ResolutionFormEditor from "./ResolutionFormEditor";
import IncidentTypesEditor from "./IncidentTypesEditor";
import LocationsEditor from "./LocationsEditor"; // loads the locations config editor
// save for later - xt added 20260531 to add inc type editor
import "./Config.css";


const Config = () => {

  // state declarations //
  const [activeTab, setActiveTab] = useState(null); // page launches with no tabs open
  const dispatch = useDispatch();
  const { getAccessTokenSilently, user } = useAuth0();
  // ------------------------------------------------------------
  // CONFIG ADMINISTRATOR IDENTITY
  // Uses Auth0 app_metadata fields reserved for Config
  // accountability and future save-history records.
  // ------------------------------------------------------------
  const appMetadata =
    user?.["https://thebrassstargroup.com/app_metadata"] || {};

  const configAdminName = [
    appMetadata.first_name,
    appMetadata.last_name,
  ]
    .filter(Boolean)
    .join(" ");

  const agency = useSelector((state) => state.agency || {});
  const agencyStubs = useSelector((state) => state.agencyStubs || {});

  useEffect(() => {
    const ensureAgencyLoaded = async () => {
      try {
        const token = await getAccessTokenSilently();

        if (
          !agencyStubs.selectedAgencyId &&
          agencyStubs.items?.length === 0
        ) {
          dispatch(requestStubs(token));
        } else if (
          agencyStubs.selectedAgencyId &&
          !agency?.details?._id
        ) {
          dispatch(
            fetchAgency(
              agencyStubs.selectedAgencyId,
              token
            )
          );
        }
      } catch (err) {
        console.error(
          "Config.js - Failed to load agency:",
          err
        );
      }
    };

    ensureAgencyLoaded();
  }, [
    agencyStubs.selectedAgencyId,
    agencyStubs.items?.length,
    agency?.details?._id,
    dispatch,
    getAccessTokenSilently,
  ]);

  return (
    <div className="container-fluid" style={{ paddingTop: 20 }}>
      {/* CONFIG CSS FENCE */}
      <div className="bsg-config">
        <h2 className="fs-4 text-center my-3">
          {agency?.details?.name?.en_US
            ? `${agency.details.name.en_US} Configuration Page`
            : "Configuration Page"}
        </h2>
        {/* ------------------------------------------------------------ */}
        {/* CONFIG ADMINISTRATOR                                        */}
        {/* Shows who is making live application configuration changes. */}
        {/* ------------------------------------------------------------ */}
        {configAdminName && (
          <div
            style={{
              textAlign: "center",
              marginTop: "-6px",
              marginBottom: "14px",
              color: "#666",
              fontSize: "0.95rem",
            }}
          >
            Configuration Administrator: {configAdminName}
          </div>
        )}


        {/* LIVE WARNING TO USER*/}
        <div className="config-live-warning">
          <div className="config-live-warning-title">
            ⚠ LIVE APPLICATION CONFIGURATION
          </div>

          <div>
            Changes made on this page will directly affect the Transit Watch
            applications used by your agency. Review all changes carefully before saving.
          </div>
        </div>
        {/* Tabs */}
        <div
          style={{
            display: "flex",
            gap: 24,
            borderBottom: "1px solid #ddd",
            marginBottom: 16,
          }}
        >
          <button
            type="button"
            onClick={() => setActiveTab("incident")}
            style={{
              border: "none",
              background: "transparent",
              padding: "12px 8px",
              color: activeTab === "incident" ? "#000" : "#0d6efd",
              fontWeight: activeTab === "incident" ? 700 : 500,
              borderBottom:
                activeTab === "incident"
                  ? "3px solid #0d6efd"
                  : "3px solid transparent",
            }}
          >
            Public App Incident Types
          </button>

          <button
            type="button"
            disabled
            title="Coming Soon"
            style={{
              border: "none",
              background: "transparent",
              padding: "12px 8px",
              color: "#6c757d",
              fontWeight: 500,
              cursor: "default",
              opacity: 0.7,
            }}
          >
            Responder App Incident Types{" "}
            <span style={{ fontSize: "0.75em", fontStyle: "italic" }}>
              Coming Soon when responder web app launches
            </span>
          </button>

          <button
            type="button"
            onClick={() => setActiveTab("locations")}
            style={{
              border: "none",
              background: "transparent",
              padding: "12px 8px",
              color: activeTab === "locations" ? "#000" : "#0d6efd",
              fontWeight: activeTab === "locations" ? 700 : 500,
              borderBottom:
                activeTab === "locations"
                  ? "3px solid #0d6efd"
                  : "3px solid transparent",
            }}
          >
            Locations
          </button>

          <button
            type="button"
            onClick={() => setActiveTab("resolution")}
            style={{
              border: "none",
              background: "transparent",
              padding: "12px 8px",
              color: activeTab === "resolution" ? "#000" : "#0d6efd",
              fontWeight: activeTab === "resolution" ? 700 : 500,
              borderBottom:
                activeTab === "resolution"
                  ? "3px solid #0d6efd"
                  : "3px solid transparent",
            }}
          >
            Resolution Button Form
          </button>
        </div>

        {activeTab === "incident" && <IncidentTypesEditor />}

        {/* {activeTab === "incident" && (
          <div style={{ padding: 12 }}>
            <em>Not built yet.</em>
          </div>
        )} */}

        {/* ------------------------------------------------------------ */}
        {/* CONFIG - LOCATIONS TAB                                      */}
        {/* Renders the Locations editor only when selected.            */}
        {/* ------------------------------------------------------------ */}
        {activeTab === "locations" && <LocationsEditor />}

        {/* Temporary: existing editor remains here until the full
            Resolution Form editor replaces it. */}
        {activeTab === "resolution" && <ResolutionFormEditor />}
      </div>
      {/* END CONFIG CSS FENCE */}
    </div>
  );
};

export default Config;